import type { SelectedFilters } from 'src/app/portfolio/state/portfolioGeneralSlice';
import type { SiteFilterOptions } from 'src/app/portfolio/state/api/siteFilterOptionsQuery';

const KBA_LEVELS = ['within_boundary', 'within_buffer', 'no_overlap'] as const;
const RISK_LEVELS = ['VERY_HIGH', 'HIGH', 'MEDIUM', 'LOW', 'VERY_LOW'] as const;
const STATE_OF_NATURE_LEVELS = ['VERY_POOR', 'POOR', 'MODERATE', 'GOOD', 'VERY_GOOD'] as const;

export const sanitizeSelectedFilters = (filters: SelectedFilters, filterOptions?: SiteFilterOptions): SelectedFilters => {
    const allowedByFilter: Record<string, Set<string>> = {
        kba: new Set(KBA_LEVELS),
        physical_risk_levels: new Set(RISK_LEVELS),
        dependency_levels: new Set(RISK_LEVELS),
        impact_levels: new Set(RISK_LEVELS),
        son_levels: new Set(STATE_OF_NATURE_LEVELS),
    };

    if (filterOptions) {
        allowedByFilter.country = new Set(filterOptions.countries.map(country => country.code));
        allowedByFilter.isic = new Set(filterOptions.isicCodes.map(isicCode => isicCode.code));
    }

    return filters.reduce<SelectedFilters>((acc, filter) => {
        const allowed = allowedByFilter[filter.name];
        if (!allowed) {
            return acc;
        }

        const values = [...new Set(filter.values.filter(value => allowed.has(value)))];
        if (values.length > 0) {
            acc.push({ name: filter.name, values });
        }
        return acc;
    }, []);
};

export const areSelectedFiltersEqual = (left: SelectedFilters, right: SelectedFilters): boolean => {
    if (left.length !== right.length) return false;
    return left.every((leftFilter, index) => {
        const rightFilter = right[index];
        if (!rightFilter || leftFilter.name !== rightFilter.name || leftFilter.values.length !== rightFilter.values.length) {
            return false;
        }
        return leftFilter.values.every((value, valueIndex) => value === rightFilter.values[valueIndex]);
    });
};
